import 'react-native-gesture-handler';
//import 'fastestsmallesttextencoderdecoder';
import App from './app/index.js';

export default App;